import {
  Box,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { MouseEventHandler } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useUsers } from "../hooks/query/useUsers";
import { mergeParams } from "../utils/url";

export const UsersPicker: React.FC<{
  value: string;
  onChange: (email: string) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled = false }) => {
  const { data: users = [] } = useUsers();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const onInvite: MouseEventHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
    navigate(
      `${pathname}?${mergeParams(searchParams, new URLSearchParams({ dialog: "invite-user" })).toString()}`,
    );
  };

  const handleChange = (event: SelectChangeEvent<typeof value>) => {
    const nextValue = event.target.value;
    if (nextValue.length > 0) {
      onChange(nextValue);
    }
  };

  return (
    <Select
      size="small"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      displayEmpty
      sx={{ width: "100%" }}
      renderValue={(selected) => {
        if (!selected) {
          return "Select an owner";
        }
        return selected;
      }}
    >
      <MenuItem key="invite-user" disabled={disabled}>
        <ListItemText onClick={onInvite}>
          <Box display="flex" gap={1} alignItems="center">
            <FontAwesomeIcon icon={faUserPlus} />
            Invite
          </Box>
        </ListItemText>
      </MenuItem>

      {users.map((user) => (
        <MenuItem value={user.email} key={user.email}>
          {user.email}
        </MenuItem>
      ))}
    </Select>
  );
};
